import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";

export const getReportData = async (payload: any, isOther: boolean) => {
  try {
    const body = { data: payload };
    const url = isOther ? urls.getOtherData : urls.getReportData;
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const addReportData = async (payload: any, isOther: boolean) => {
  try {
    const body = { data: payload };
    const callParams = await getCallParams("POST", body);
    const url = isOther ? urls.addDataOther : urls.addData;
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchOtherList = async () => {
  try {
    const callParams = await getCallParams("POST", {});
    const url = urls.getPlanets;
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchOtherValues = async (name: string) => {
  try {
    const body = {
      name: name,
    };
    const callParams = await getCallParams("POST", body);
    const url = urls.getPlanets;
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
